export default __webpack_public_path__ + "static/media/Type-B.33171481.jpg";